/**
 * Provides entities as semantic model.
 *
 * It translates generic entities and interprets them as semantic entities.
 *
 * Todo: the translation is identity now, but it should be more complex
 *
 * @deprecated Use model store instead to manage the model state.
 */
export class SemanticModelAdapter {
    entityModel;
    constructor(entityModel) {
        this.entityModel = entityModel;
    }
    getId() {
        return this.entityModel.getId();
    }
    getAlias() {
        return this.entityModel.getAlias();
    }
    setAlias(alias) {
        this.entityModel.setAlias(alias);
    }
    getEntities() {
        return this.entityModel.getEntities();
    }
    subscribeToChanges(callback) {
        return this.entityModel.subscribeToChanges(callback);
    }
}
//# sourceMappingURL=semantic-model-adapter.js.map